import { Rect } from './../math';
import { QuadRoot } from './QuadRoot';
export class QuadNode extends QuadRoot {
    constructor(rect) {
        super();
        this.children = [];
        this.rect = rect;
    }
    inBounds(rect) {
        const nodeRect = this.rect;
        const nodeBottomRight = nodeRect.bottomRight();
        const bottomRight = rect.bottomRight();
        const inBounds = nodeRect.x <= rect.x && nodeRect.y <= rect.y && bottomRight.x <= nodeBottomRight.x &&
            bottomRight.y <= nodeBottomRight.y;
        return inBounds;
    }
    overlapsBounds(rect) {
        return this.rect.overlaps(rect);
    }
    insert(shape, bounds) {
        let inserted = false;
        const children = this.children;
        const length = children.length;
        if (this.inBounds(bounds)) {
            if (!length && this.shapes.length < 4) {
                this._add(shape, bounds);
            }
            else {
                if (!length) {
                    this._initChildren();
                }
                for (let idx = 0; idx < children.length; idx++) {
                    if (children[idx].insert(shape, bounds)) {
                        inserted = true;
                        break;
                    }
                }
                if (!inserted) {
                    this._add(shape, bounds);
                }
            }
            inserted = true;
        }
        return inserted;
    }
    _initChildren() {
        const rect = this.rect, children = this.children, shapes = this.shapes, center = rect.center(), halfWidth = rect.width / 2, halfHeight = rect.height / 2;
        let childIdx, shapeIdx;
        children.push(new QuadNode(new Rect(rect.x, rect.y, halfWidth, halfHeight)), new QuadNode(new Rect(center.x, rect.y, halfWidth, halfHeight)), new QuadNode(new Rect(rect.x, center.y, halfWidth, halfHeight)), new QuadNode(new Rect(center.x, center.y, halfWidth, halfHeight)));
        for (shapeIdx = shapes.length - 1; shapeIdx >= 0; shapeIdx--) {
            for (childIdx = 0; childIdx < children.length; childIdx++) {
                if (children[childIdx].insert(shapes[shapeIdx].shape, shapes[shapeIdx].bounds)) {
                    shapes.splice(shapeIdx, 1);
                    break;
                }
            }
        }
    }
    hitTestRect(rect, exclude) {
        let idx;
        const children = this.children;
        const length = children.length;
        let hit = false;
        if (this.overlapsBounds(rect)) {
            if (super.hitTestRect(rect, exclude)) {
                hit = true;
            }
            else {
                for (idx = 0; idx < length; idx++) {
                    if (children[idx].hitTestRect(rect, exclude)) {
                        hit = true;
                        break;
                    }
                }
            }
        }
        return hit;
    }
}
